import { render, staticRenderFns } from "./RedisCacheManagement.vue?vue&type=template&id=fa8c9e5c&scoped=true&"
import script from "./RedisCacheManagement.vue?vue&type=script&lang=js&"
export * from "./RedisCacheManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8c9e5c",
  null
  
)

export default component.exports